import React from 'react';
import styles from '@/assets/styles/TermsOfService.module.less';

const TermsOfService: React.FC = () => {
  return (
    <div className={styles.termsContainer}>
      <div className={styles.contentWrapper}>
        {/* 标题区域 */}
        <div className={styles.titleSection}>
          <h1>服务条款</h1>
          <div className={styles.subtitle}>欢迎使用FuriFlow日语学习平台</div>
          <div className={styles.dateInfo}>
            <p>
              <strong>更新日期：</strong>2024年12月1日
            </p>
            <p>
              <strong>生效日期：</strong>2024年12月1日
            </p>
          </div>
        </div>

        {/* 主要内容 */}
        <div className={styles.mainContent}>
          {/* 介绍文本 */}
          <div className={styles.introText}>
            欢迎使用FuriFlow（胡哩胡唠）日语学习平台！这些服务条款规定了您使用我们服务的条件和规则。
            请在使用我们的服务之前仔细阅读这些条款。使用我们的服务即表示您同意遵守这些条款。
          </div>

          <h2 className={styles.sectionTitle}>1. 服务说明</h2>

          <h3 className={styles.subsectionTitle}>1.1 服务内容</h3>
          <p className={styles.contentText}>FuriFlow为您提供以下服务：</p>
          <ul className={styles.termsList}>
            <li>
              <strong>文本分析服务：</strong>
              为日语文本自动添加振假名（フリガナ），帮助您学习日语发音
            </li>
            <li>
              <strong>词典查询服务：</strong>提供日语词汇的详细解释、发音、用法示例等信息
            </li>
            <li>
              <strong>词汇学习管理：</strong>创建和管理个人词汇表，记录学习进度和历史
            </li>
            <li>
              <strong>学习记录功能：</strong>跟踪您的学习活动，提供个性化的学习建议
            </li>
          </ul>

          <h3 className={styles.subsectionTitle}>1.2 服务可用性</h3>
          <p className={styles.contentText}>
            我们致力于提供稳定可靠的服务，但不保证服务100%可用。服务可能因维护、升级或其他技术原因暂时中断。
            我们将尽力提前通知重要的服务中断。
          </p>

          <h2 className={styles.sectionTitle}>2. 用户义务</h2>

          <h3 className={styles.subsectionTitle}>2.1 账户责任</h3>
          <p className={styles.contentText}>您需要：</p>
          <ul className={styles.termsList}>
            <li>
              <strong>提供真实信息：</strong>在注册时提供准确、完整的个人信息
            </li>
            <li>
              <strong>保护账户安全：</strong>妥善保管用户名和密码，不得与他人共享
            </li>
            <li>
              <strong>及时更新信息：</strong>如个人信息发生变化，及时更新账户信息
            </li>
            <li>
              <strong>承担账户责任：</strong>对使用您账户进行的所有活动承担责任
            </li>
          </ul>

          <h3 className={styles.subsectionTitle}>2.2 使用规范</h3>
          <p className={styles.contentText}>使用我们的服务时，您承诺：</p>
          <ul className={styles.termsList}>
            <li>
              <strong>合法使用：</strong>仅将服务用于合法的学习和研究目的
            </li>
            <li>
              <strong>禁止滥用：</strong>不得恶意攻击、滥用系统资源或干扰服务正常运行
            </li>
            <li>
              <strong>尊重他人：</strong>不得发布违法、有害、威胁性或侵犯他人权利的内容
            </li>
            <li>
              <strong>遵守规则：</strong>遵守所有适用的法律法规和平台规则
            </li>
          </ul>

          <div className={styles.warningBox}>
            <h3>重要提醒</h3>
            <p>
              违反使用规范可能导致账户被暂停或终止。我们保留在不事先通知的情况下采取必要措施的权利。
            </p>
          </div>

          <h2 className={styles.sectionTitle}>3. 知识产权</h2>

          <h3 className={styles.subsectionTitle}>3.1 平台内容</h3>
          <p className={styles.contentText}>
            FuriFlow平台上的所有内容，包括但不限于软件、设计、文本、图片、商标等，均受知识产权法保护。
            未经明确授权，您不得复制、修改、分发或商业使用这些内容。
          </p>

          <h3 className={styles.subsectionTitle}>3.2 用户生成内容</h3>
          <p className={styles.contentText}>
            您在使用服务过程中创建的词汇表、学习记录等内容归您所有。但您授予我们使用这些内容来改善服务的权利。
          </p>

          <h2 className={styles.sectionTitle}>4. 服务变更和终止</h2>

          <h3 className={styles.subsectionTitle}>4.1 服务变更</h3>
          <p className={styles.contentText}>
            我们可能会随时修改、升级或停止部分或全部服务功能。我们将通过网站公告、邮件或其他方式通知重要变更。
          </p>

          <h3 className={styles.subsectionTitle}>4.2 服务终止</h3>
          <p className={styles.contentText}>在以下情况下，我们有权终止为您提供服务：</p>
          <ul className={styles.termsList}>
            <li>违反本服务条款或相关法律法规</li>
            <li>长期不活跃的账户（超过12个月未登录）</li>
            <li>服务终止或重大调整</li>
            <li>其他我们认为有必要终止服务的情况</li>
          </ul>

          <h2 className={styles.sectionTitle}>5. 免责声明</h2>

          <h3 className={styles.subsectionTitle}>5.1 服务限制</h3>
          <p className={styles.contentText}>
            我们的服务按&quot;现状&quot;提供，不对以下方面提供保证：
          </p>
          <ul className={styles.termsList}>
            <li>
              <strong>准确性：</strong>翻译、发音标注等功能的绝对准确性
            </li>
            <li>
              <strong>完整性：</strong>词典内容的完整性和实时更新
            </li>
            <li>
              <strong>可用性：</strong>服务的持续可用性和无故障运行
            </li>
            <li>
              <strong>适用性：</strong>服务对您特定需求的适用性
            </li>
          </ul>

          <h3 className={styles.subsectionTitle}>5.2 责任限制</h3>
          <p className={styles.contentText}>
            在法律允许的最大范围内，我们不对因使用或无法使用服务而导致的任何直接或间接损失承担责任。
          </p>

          <h2 className={styles.sectionTitle}>6. 争议解决</h2>

          <p className={styles.contentText}>
            如果您对服务有任何争议或问题，我们建议您首先通过以下方式与我们联系：
          </p>

          <div className={styles.contactSection}>
            <h2>联系我们</h2>
            <div className={styles.contactInfo}>
              <div>
                <strong>邮箱：</strong>support@furiflow.com
              </div>
              <div>
                <strong>网站：</strong>https://furiflow.com
              </div>
            </div>
          </div>

          <p className={styles.contentText}>
            本服务条款的解释和争议解决适用中华人民共和国法律。如无法通过协商解决争议，
            应提交至服务提供方所在地有管辖权的人民法院处理。
          </p>

          <h2 className={styles.sectionTitle}>7. 条款变更</h2>

          <p className={styles.contentText}>
            我们可能会不时修改这些服务条款。重要变更将通过网站公告、邮件或其他适当方式通知您。
            继续使用服务即表示您接受修改后的条款。
          </p>

          <p className={styles.contentText}>建议您定期查看本页面以了解最新的服务条款。</p>

          <div className={styles.effectiveSection}>
            <h2>生效声明</h2>
            <p>
              本服务条款自2024年12月1日起生效。如果您在条款生效后继续使用FuriFlow服务，
              即视为您已阅读、理解并同意遵守本服务条款的所有内容。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
